import { Expose } from 'class-transformer';
import type rewardInterface from '../types/Reward';

export default class RewardsProgram {
  @Expose() name: (string | null) = null;
  @Expose() available_rewards: rewardInterface[] = [];
  @Expose() program: (string | null) = null;
  @Expose() threshold: (number | null) = null;
  @Expose() current_points: (number | null) = null;
  @Expose() card_number: (string | null) = null;

  constructor(
    name: string,
    available_rewards: rewardInterface[],
    program: string,
    threshold: number,
    current_points: number,
    card_number: string,
  ) {
    this.name = name || null;
    this.available_rewards = available_rewards || [];
    this.program = program || null;
    this.threshold = threshold || null;
    this.current_points = current_points || null;
    this.card_number = card_number || null;
  }
}